// extracted by mini-css-extract-plugin
export default {"sticky_contact":"ContactUs_sticky_contact__ANFrY","bordered":"ContactUs_bordered__BFlqZ"};